export const REPRESENTATIVE = 'REPRESENTATIVE'
export const STORE = 'STORE'

export const StatisticsScopes = {
  REPRESENTATIVE: REPRESENTATIVE.toLowerCase(),
  STORE: STORE.toLowerCase(),
}

export const DefaultCheckoutStyling = {
  COLOUR: '#009CDA',
  FONT: 'Avenir',
  TERMS_LINK: '',
}

export const STORE_STATUS_UNKNOWN = 'UNKNOWN'
export const VALID_STORE_STATUSES = ['ACTIVE', 'VIP']

export const CartItemMergeParams = {
  DESCRIPTION: 'DESCRIPTION',
  EXTERNAL_ID: 'EXTERNAL_ID',
  REFERENCE: 'REFERENCE',
  TYPE: 'TYPE',
  UNIT: 'UNIT',
  TOTAL_AMOUNT_INC_VAT: 'TOTAL_AMOUNT_INC_VAT',
  TOTAL_AMOUNT_EX_VAT: 'TOTAL_AMOUNT_EX_VAT',
  UNIT_PRICE_INC_VAT: 'UNIT_PRICE_INC_VAT',
  VAT_RATE: 'VAT_RATE',
}

export const CartItemMergeParamLabelTranslations = {
  DESCRIPTION: 'paymentSettings.cartParams.labels.description',
  EXTERNAL_ID: 'paymentSettings.cartParams.labels.externalId',
  REFERENCE: 'paymentSettings.cartParams.labels.reference',
  TYPE: 'paymentSettings.cartParams.labels.type',
  UNIT: 'paymentSettings.cartParams.labels.unit',
  TOTAL_AMOUNT_INC_VAT: 'paymentSettings.cartParams.labels.totalAmountIncVat',
  TOTAL_AMOUNT_EX_VAT: 'paymentSettings.cartParams.labels.totalAmountExVat',
  UNIT_PRICE_INC_VAT: 'paymentSettings.cartParams.labels.unitPriceIncVat',
  VAT_RATE: 'paymentSettings.cartParams.labels.vatRate',
}
